module.exports = __webpack_public_path__ + "img/facebook.021ada14.png";